import { Layout, Space, Typography } from "antd";
import { Link } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";

const { Footer: AntFooter } = Layout;
const { Text } = Typography;

const Footer = ({ isDarkMode }) => {
    const { t } = useLanguage();

    return (
        <AntFooter
            style={{
                textAlign: "center",
                background: isDarkMode ? "#0a0a0a" : "#f8fafc",
                padding: "24px 50px",
                borderTop: isDarkMode ? "1px solid #303030" : "1px solid #f0f0f0",
                transition: "all 0.3s ease",
            }}
        >
            <Space direction="vertical" size="middle">
                <Space split={<Divider type="vertical" />} wrap>
                    <Link to="/home" style={{ color: isDarkMode ? "#e5e7eb" : "#4b5563" }}>
                        {t("nav.home")}
                    </Link>
                    <Link to="/jobs" style={{ color: isDarkMode ? "#e5e7eb" : "#4b5563" }}>
                        {t("nav.dashboard")}
                    </Link>
                    <Link to="/analytics" style={{ color: isDarkMode ? "#e5e7eb" : "#4b5563" }}>
                        {t("nav.analytics")}
                    </Link>
                    <Link to="/apply" style={{ color: isDarkMode ? "#e5e7eb" : "#4b5563" }}>
                        {t("nav.applyService")}
                    </Link>
                </Space>

                <Space split={<span style={{ color: "#d1d5db" }}>|</span>} wrap>
                    <Link to="/terms" style={{ color: isDarkMode ? "#9ca3af" : "#6b7280", fontSize: "14px" }}>
                        {t("nav.terms")}
                    </Link>
                    <Link to="/privacy" style={{ color: isDarkMode ? "#9ca3af" : "#6b7280", fontSize: "14px" }}>
                        {t("nav.privacy")}
                    </Link>
                </Space>

                <Text type="secondary" style={{ fontSize: "12px" }}>
                    © {new Date().getFullYear()} {t("nav.title")}. All rights reserved.
                </Text>
            </Space>
        </AntFooter>
    );
};

// Simple Divider replacement since we are inside Space
const Divider = ({ type }) => (
    <span style={{ color: "#d1d5db", margin: "0 8px" }}>|</span>
);

export default Footer;
